/**
 * 📣 마케팅 — /marketing (v2.245.0 · 2026-10-13 · 사용자 개발 계획)
 *
 * 사용자: 「메뉴 이름을 마케팅으로 바꾸고, 지금 부스 설문집계는 마케팅 안에 세부메뉴로 넣어줘.
 *   마케팅 안에는 명절선물 이라는 메뉴를 새로 만들어서 …」
 *   → 메뉴는 화면 하나에 한 줄(v2.135.0 원칙) · 세부 메뉴는 화면 안 탭: [🎁 명절선물] · [📋 부스 설문 집계].
 *   탭은 주소 `?tab=gifts|survey` 로 기억한다 · 옛 주소 /survey-results 는 /marketing?tab=survey 로 넘긴다(즐겨찾기 보호).
 * 권한: sales 이상(viewer 는 라우트에서 막고, 서버도 /holiday-gifts·/survey 를 막는다).
 */

import { lazy, Suspense } from 'react';
import { useSearchParams } from 'react-router-dom';
import { PageTabs } from '../components/ui/PageTabs';
import { LoadingLines } from '../components/ui/Skeleton';

const HolidayGiftTab = lazy(() => import('../components/HolidayGiftTab').then((m) => ({ default: m.HolidayGiftTab })));
const MarketingEventTab = lazy(() => import('../components/MarketingEventTab').then((m) => ({ default: m.MarketingEventTab })));
const SurveyResultsPage = lazy(() => import('./SurveyResults').then((m) => ({ default: m.SurveyResultsPage })));

/** 탭 키 — `check:menu` 가 이 줄을 읽어 TAB_TITLES 와 대조한다 · events = 🎪 전시회(v2.297.0 「행사」 · 개발요청 #13 → v2.300.0 이름만 「전시회」 · 키는 주소 호환으로 그대로) */
type MarketingTab = 'gifts' | 'events' | 'survey';

export function MarketingPage() {
  const [params, setParams] = useSearchParams();
  const raw = params.get('tab');
  const tab: MarketingTab = raw === 'survey' ? 'survey' : raw === 'events' ? 'events' : 'gifts';
  const go = (t: MarketingTab) => {
    const next = new URLSearchParams(params);
    if (t === 'gifts') next.delete('tab'); else next.set('tab', t);
    // 탭마다 다른 뜻으로 쓰는 열쇠(명절·전시회 번호 · 거래처별 보기)는 탭을 옮기면 비운다
    next.delete('event');
    next.delete('view');
    setParams(next, { replace: true });
  };
  return (
    <div className="p-6 md:p-8">
      <h1 className="ui-page-title">마케팅</h1>
      <p className="ui-page-sub mb-3">명절 선물 계획·기록 · 전시회 비용·전년 대비 · 전시회 부스 설문 집계</p>
      <PageTabs
        tabs={[
          { key: 'gifts', label: '🎁 명절선물' },
          { key: 'events', label: '🎪 전시회' },
          { key: 'survey', label: '📋 부스 설문 집계' },
        ]}
        value={tab}
        onChange={go}
        ariaLabel="마케팅 보기"
      />
      <Suspense fallback={<div className="py-16 text-center text-slate-400"><LoadingLines /></div>}>
        {tab === 'gifts' ? <HolidayGiftTab /> : tab === 'events' ? <MarketingEventTab /> : <SurveyResultsPage embedded />}
      </Suspense>
    </div>
  );
}
